export default __webpack_public_path__ + "static/media/noiseLayer.880de64f.png";